import { render, staticRenderFns } from "./documento-form.vue?vue&type=template&id=b4a8777c&scoped=true"
import script from "./documento-form.vue?vue&type=script&lang=js"
export * from "./documento-form.vue?vue&type=script&lang=js"
import style0 from "./documento-form.vue?vue&type=style&index=0&id=b4a8777c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a8777c",
  null
  
)

export default component.exports